import api from './api';

const base = '/Integracoes/Whatsapp';
export const getWhatsappOptions = () =>
  api.get(`${base}/URL`).then(({ data }) => data);
export const getWhatsappAccounts = (id) =>
  api.get(base, { params: { integra_access_id: id } }).then(({ data }) => data);
export const postWhatsapp = (action, id, data) =>
  api.post(`${base}/${action}`, { ...data, integra_access_id: id });
export const deleteWhatsappNumber = (id, phone_number_id) =>
  api.delete(`${base}/Number`, {
    data: { integra_access_id: id, phone_number_id },
  });

// The generic endpoint also returns credentials. Keep only editable preferences.
export const getWhatsappPreferences = async (id) => {
  const { data } = await api.get('/Integracoes');
  const integration = data.find(
    (item) => String(item.id) === String(id) && item.api === 'WHATSAPP'
  );
  if (!integration) throw new Error('Integração WhatsApp não encontrada');
  const access = integration.access_data || {};
  return {
    nome_integracao: access.nome_integracao || '',
    user_notification: access.user_notification ?? null,
    enviar_mensagens: access.enviar_mensagens === true,
  };
};

export const saveWhatsappPreferences = async (id, values) => {
  await postWhatsapp('Configs', id, {
    user_notification: values.user_notification ?? null,
  });
  return api.post('/Integracoes', {
    id,
    api: 'WHATSAPP',
    nome_integracao: values.nome_integracao,
    enviar_mensagens: values.enviar_mensagens,
  });
};
